const wikiMainSearch = document.getElementById('.wiki-main-search');

if (wikiMainSearch) {
    
}